import { get } from 'lodash';

const getConsentDownloadUrl = (state) => (
  get(state, 'session.app_support.consent.download_url')
);

export default getConsentDownloadUrl;
